import ApiService from '@/services/api.service'

const HighAlertAssessmentNotes = {

    getAll(parameter){
        
        const requestData = {
          method: 'get',
          url: "/HighAlertAssessmentNotes/",
          headers: {
            
          },
          params: {
            HeaderID: parameter.HeaderID,
            TitleRecNo: parameter.TitleRecNo,
          }
        }
        return ApiService.customRequest(requestData);
    },

    Add(data){
      return ApiService.post(`/HighAlertAssessmentNotes/`, data);
    },

    Update(Id,data){        
      return ApiService.put(`/HighAlertAssessmentNotes/${Id}`,data);
    }, 
  }

export default HighAlertAssessmentNotes;